{
  "languages": {
    "arabic": "아랍어",
    "belarusian": "벨라루스어",
    "chinese": "중국어",
    "dutch": "네덜란드어",
    "english": "영어",
    "french": "프랑스어",
    "german": "독일어",
    "italian": "이탈리아어",
    "japanese": "일본어",
    "korean": "한국어",
    "lithuanian": "리투아니아어",
    "portuguese": "포르투갈어",
    "romanian": "루마니아어",
    "spanish": "스페인어",
    "turkish": "터키어"
  }
}
